module.exports = __webpack_public_path__ + "6565b7691c5571d11f1f157d232e5238.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/22-09-01Nagelritz-mini.jpg
// module id = 552
// module chunks = 0